import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: 'Material Icons Outlined'
  }
}));

/**
 * @author odin, nick
 * @component BaseMuiIcon
 * @description ✅ 基礎 Icon 組件，支持 ref 轉發
 */
export const BaseMuiIcon = React.forwardRef(
  ({ className, isIconButton = false, children, ...props }, ref) => {
    const classes = useStyles();
    
    return isIconButton ? (
      <IconButton
        ref={ref}  // ✅ 轉發 ref 給 IconButton
        className={`${classes.root} ${className}`}
        {...props}
      >
        {children && <Icon>{children}</Icon>}
      </IconButton>
    ) : (
      <Icon
        ref={ref}  // ✅ 轉發 ref 給 Icon
        className={`${classes.root} ${className}`}
        {...props}
      >
        {children}
      </Icon>
    );
  }
);

BaseMuiIcon.displayName = 'BaseMuiIcon';

BaseMuiIcon.propTypes = {
  className: PropTypes.string,
  isIconButton: PropTypes.bool,
  children: PropTypes.node
};

export default BaseMuiIcon;
